<template>
    <div class="repay__bank-transaction">
        <div class="repay__bank-transaction__info">
            <div class="repay__bank-transaction__info-title">
                <img class="repay__bank-transaction__info-title-icon" src="@/assets/svg/icons/icon_3_mk.svg" alt="" />
                <p class="repay__bank-transaction__info-title-text">Как внести платёж с банковской карты Visa или MasterCard</p>
            </div>
            <div class="repay__bank-transaction__info-text">Как внести платёж в отделении банка</div>
            <div class="repay__bank-transaction__info-description">Выбирая этот способ оплаты, помните, что банковский перевод <br/>может идти от 1 до 3 рабочих дней. Посетите отделение банка <br/>заранее, чтобы внести платёж вовремя.</div>
        </div>
        <div class="repay__bank-transaction__requisites">
            <div class="repay__bank-transaction__requisites-title">Для перевода вам потребуются ваш ИИН, номер кредитного договора <br/>и банковские реквизиты Микро:</div>
            <div class="repay__bank-transaction__requisites-block">
                <div class="repay__bank-transaction__requisites-block-title">Получатель:</div>
                <div class="repay__bank-transaction__requisites-block-text">МФО «MicroFin» ТОО</div>
                <div class="repay__bank-transaction__requisites-block-title">БИН:</div>
                <div class="repay__bank-transaction__requisites-block-text">231140034522</div>
                <div class="repay__bank-transaction__requisites-block-title">Номер счёта/ IBAN/ ИИК:</div>
                <div class="repay__bank-transaction__requisites-block-text">KZ04601A861026938571</div>
                <div class="repay__bank-transaction__requisites-block-title">Наименование банка:</div>
                <div class="repay__bank-transaction__requisites-block-text">АО «Народный Банк Казахстана»</div>
                <div class="repay__bank-transaction__requisites-block-title">БИК:</div>
                <div class="repay__bank-transaction__requisites-block-text">HSBKKZKX</div>
                <div class="repay__bank-transaction__requisites-block-title">КБЕ:</div>
                <div class="repay__bank-transaction__requisites-block-text">17</div>
            </div>
            <div class="repay__bank-transaction__requisites-description">
                <ol class="repay__bank-transaction__requisites-description-first">
                    <li class="repay__bank-transaction__requisites-description-first-item">Внесите необходимую сумму на счёт в отделении своего банка</li>
                    <li class="repay__bank-transaction__requisites-description-first-item"><b>Оформите платежное поручение, в назначении платежа укажите:</b></li>
                </ol>
                <ul class="repay__bank-transaction__requisites-description-second">
                    <li class="repay__bank-transaction__requisites-description-second-item">Погашение микрокредита</li>
                    <li class="repay__bank-transaction__requisites-description-second-item">ИИН</li>
                    <li class="repay__bank-transaction__requisites-description-second-item">Полное имя</li>
                    <li class="repay__bank-transaction__requisites-description-second-item">Номер договора</li>
                </ul>
                <div class="repay__bank-transaction__requisites-description-info">
                    <img class="repay__bank-transaction__requisites-description-info-image" src="@/assets/svg/icons/info_p.svg" alt="" />
                    <div class="repay__bank-transaction__requisites-description-info-text">Квитанцию сохраните. Она потребуется, если по какой-то причине мы не получим платёж через терминал</div>
                </div>
            </div>
        </div>
        <div class="repay__bank-transaction__questions">
            <div class="repay__bank-transaction__questions-title">Есть вопросы?</div>
            <div class="repay__bank-transaction__questions-text">Найдите ответ в разделе <router-link tag="a" :to="{name: 'FAQ' }">«Вопросы и ответы»</router-link></div>
        </div>
    </div>
</template>

<script>
    export default{
    	name: 'RepayBankCard',
        metaInfo: {
            title: 'Как внести платёж в отделении банка – Микро',
            meta: [
                {name: 'description', content: 'Выбирая этот способ оплаты, помните, что банковский перевод может идти от 1 до 3 рабочих дней. Посетите отделение банка заранее, чтобы внести платёж вовремя'}
            ],
        },
        computed: {
        },
    }
</script>

<style lang="scss">
@import "~@/assets/scss/variable";

.repay__bank-transaction {
    width: 100%;
    &__info {
        display: inline-flex;
        flex-flow: column wrap;
        align-items: flex-start;
        justify-content: flex-start;

        width: 100%;
        margin-bottom: 29px;
    }
    &__info-title {
        display: inline-flex;
        flex-flow: row nowrap;
        align-items: center;
        justify-content: flex-start;

        width: 100%;
        border-bottom: 1px solid $gray-mint;
        padding-bottom: 18px;
        margin-bottom: 21px;
    }
    &__info-title-icon {
        width: 44px;
        height: 44px;
    }
    &__info-title-text {
        margin-left: 21px;
        text-align: left;
        color: $gray-dim-dark;
        font-size: 16px;
        line-height: 26px;
        font-family: $RobotoBold;
    }
    &__info-title {

    }
    &__info-description {
        text-align: left;
        color: $gray-dim-dark;
        font-size: 16px;
        line-height: 24px;
        font-family: $RobotoRegular;
    }
    &__info-text {
        margin-bottom: 24px;
        text-align: left;
        color: $gray-dim-dark;
        font-size: 16px;
        line-height: 26px;
        font-family: $RobotoBold;
    }
    &__requisites {
        width: 100%;
    }
    &__requisites-title {
        margin-bottom: 14px;
        text-align: left;
        color: $gray-dim-dark;
        font-size: 16px;
        line-height: 26px;
        font-family: $RobotoBold;
    }
    &__requisites-block {
        width: 100%;
        margin-bottom: 39px;
        padding: 23px 36px 22px;
        background: #FFEFCB;
    }
    &__requisites-block-title {
        margin-bottom: 4px;
        text-align: left;
        color: $yellow-1;
        font-size: 18px;
        line-height: 22px;
        font-family: $RobotoBold;
    }
    &__requisites-block-text {
        margin-bottom: 8px;
        text-align: left;
        color: $gray-dim-dark;
        font-size: 14px;
        line-height: 20px;
        font-family: $RobotoRegular;
    }
    &__requisites-description {
        margin-bottom: 59px;
    }
    &__requisites-description-first {
        margin-left: 20px;
        text-align: left;
    }
    &__requisites-description-first-item {
        margin-bottom: 16px;
    }
    &__requisites-description-second {
        margin: 0 0 16px 20px;
        text-align: left;
    }
    &__requisites-description-second-item {
        margin-bottom: 4px;
    }
    &__requisites-description-info {
        width: 100%;
        padding: 18px 20px 18px 32px;
        background-color: $tooltip_background;
    }
    &__requisites-description-info-image {
        display: inline;
        float: left;
        width: 26px;
        height: 22px;
        margin-right: 8px;
    }
    &__requisites-description-info-text {
        text-align: left;
        color: $gray-dim-dark;
        font-size: 12px;
        line-height: 22px;
        font-family: $RobotoRegular;
    }
    &__questions {}
    &__questions-title {
        margin-bottom: 26px;
        color: $purple-site;
        text-align: left;
        font-family: $MontserratMedium;
        font-size: 30px;
    }
    &__questions-text {
        margin-bottom: 29px;
        color: $gray-dim-dark;
        text-align: left;
        font-family: $RobotoRegular;
        font-size: 16px;
    }
    &__questions-info {}
    &__questions-info-phone {
        margin-bottom: 7px;
        color: $gray-dim-dark;
        text-align: left;
        font-family: $RobotoRegular;
        font-size: 20px;
    }
    &__questions-info-date {
        color: $gray-dim-dark;
        text-align: left;
        font-family: $RobotoRegular;
        font-size: 12px;
    }
}
@media screen and (max-width: 500px) {
    .repay__bank-transaction {
        &__requisites-description-info {
            width: 100%;
        }
    }
}
</style>
